import { isObject } from '@pineapplelab/util';
import { FBase } from './FBase';
import { SocialMediaEnum } from 'src/app/enums/socialMedia.enum';
import { AboutUs } from './about-us';
import { LandingPageServiceUtils } from 'src/app/utils/landing-page/landing-page-service.utils';
import { ILandingPageServiceSuite } from 'src/app/interfaces/landing-page-service-suite.interface';

export class LandingPage extends FBase {
    projectName: string = null;
    whiteLogo: string = null;
    blackLogo: string = null;
    showCarouselBanner: boolean = true; // not used

    home: Partial<LandingPage.IBaseModel> = { title: null, highlightedText: null, description: null, img: null };
    carousel: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: true }; // not used
    services: ILandingPageServiceSuite = { title: null, description: null, show: true, list: LandingPageServiceUtils.getEmptyServices() };
    imageAndText: Partial<LandingPage.IBaseModel> = { title: null, description: null, secondDescription: null, show: true, img: null };

    process: Partial<LandingPage.IProcess> = { title: null, description: null, show: true, steps: [] };
    solutions: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: true, img: null };
    features1: Partial<LandingPage.IFeatures1> = {
        show: true,
        main: { title: null, description: null },
        img: null,
        list: [],
        subMain: { title: null, description: null },
    };
    features2: Partial<LandingPage.IList> = { title: null, description: null, show: true, list: [], img: null };
    clients: Partial<LandingPage.IList> = { title: null, description: null, show: true, list: [] };
    projects: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: true, project_page_title: null, project_page_description: null, see_our_projects: null  };
    testimonials: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: true, btn_text: null};
    meetTheTeam: Partial<LandingPage.IBaseModel> = { title: null, description: null, img: null };
    testimonialsList: Partial<LandingPage.IListTestimonials> = { title: null, description: null, list: [] };
    pricing: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: false };
    banner: Partial<LandingPage.IBanner> = { title: null, description: null, button: null };
    workingProcess: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: true };
    whatMakeUsDifferent: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: true, img: null };
    creativeSmartAwesome: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: true };
    blogs: Partial<LandingPage.ILandingBlogs> = { title: null, description: null };
    socialMedia: Partial<LandingPage.ISocialMedia>[] = [];
    community: Partial<LandingPage.IBaseModel> = { title: null, description: null, show: true };
    company: Partial<LandingPage.IContact> = {
        email: null,
        phone: null,
        location: { lat: 0, lng: 0 },
        zipCode: null,
        address: null,
        showContactFormSection: true,
        showMapSection: true,
        contactFormTitle: null,
        contactFormDescription: null,
    };

    footer: Partial<LandingPage.IBaseModel> = { title: null, description: null };

    aboutUs: AboutUs;

    __fileWhiteLogo: File;
    __fileBlackLogo: File;
    __fileSolutionImage: File;
    __fileWhatMakeUsDifferentImage: File;
    __fileTestimonialsImage: File;
    __fileFooterImage: File;

    constructor(json?: { [key: string]: any }) {
        super();
        if (isObject(json)) {
            this.fromJson(json);
        }
    }
}

export namespace LandingPage {
    export const PATH = 'landingPage';

    export interface IBasicProperties {
        title: string;
        highlightedText?: string;
        description: string;
        secondDescription?: string;
        img: string;
        link?: string;
        project_page_title?: string;
        project_page_description?: string;
        see_our_projects?: string;
        btn_text?: string;
    }

    export interface IContact extends IBaseModel {
        contactFormTitle: string;
        contactFormDescription: string;
        showMapSection: boolean;
        showContactFormSection: boolean;
    }

    export interface IBanner extends IBasicProperties {
        button: string;
    }

    export interface IClients extends IBasicProperties {}

    export interface IBaseModel extends IBasicProperties {
        show: boolean;
        phone: string;
        email: string;
        address: string;
        location: { lat: number; lng: number };
        zipCode: string;
    }
    export interface ILandingBlogs extends IBaseModel {
        title: string;
        description: string;
    }
    export interface IList extends IBaseModel {
        list: IBasicProperties[];
    }

    export interface IBasicTestimonial {
        name: string;
        description: string;
        position: string;
    }

    export interface IListTestimonials extends IBaseModel {
        list: IBasicTestimonial[];
    }

    export interface IFeatures1 extends IBaseModel {
        main: Omit<IBasicProperties, 'img'>;
        subMain: Omit<IBasicProperties, 'img'>;
        list: IBasicProperties[];
    }

    export interface IServices extends IBaseModel {
        list: Partial<IBasicProperties>[];
    }

    export interface IProcess extends IBaseModel {
        steps: Omit<IBasicProperties, 'img'>[];
    }

    export interface ISocialMedia extends IBasicProperties {
        link: string;
        __fileImage?: File;
        name: SocialMediaEnum;
    }
}
